import { axiosPatientInstance } from "config";
import { PaymentForm, PaymentType } from "enums";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

type UseCreateEncounterPaymentPayload = {
  type: PaymentType;
  form: PaymentForm;
  transactionNumber: string;
  amountDue: string;
  amountPaid: string;
};

function useCreateEncounterPayment(encounterId: string) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["createEncounterPayment", { encounterId }],
    (input: FormData) =>
      axiosPatientInstance.post(
        `v1/encounter/${encounterId}/form/payment`,
        input
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["encounterPayments", { encounterId }]);
        queryClient.invalidateQueries(["encounterFormStatus", { encounterId }]);
        queryClient.invalidateQueries(["encounterOverview", { encounterId }]);
      },
    }
  );
}

export type { UseCreateEncounterPaymentPayload };
export { useCreateEncounterPayment };
